import React, { useState, useEffect } from 'react';
import { Form, Dropdown } from 'react-bootstrap'
import { contact_info, social_media, services, faqQuestions } from '../constant.js';
import { MyButton } from './ui/MyButton.js';
import arrow from '../assets/images/arrow.svg';
import Faqs from './ui/Faqs.js';

const ContactUs = () => {
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        subject: "",
        product: "",
        message: "",
    });
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.firstName.trim()) newErrors.firstName = "First Name is required.";
        if (!formData.lastName.trim()) newErrors.lastName = "Last Name is required.";
        if (!formData.email.trim()) {
            newErrors.email = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Invalid email address.";
        }
        if (!formData.phone.trim()) newErrors.phone = "Phone number is required.";
        if (!formData.product.trim()) newErrors.product = "SPlease select product";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleDropdownChange = (e) => {
        setFormData({ ...formData, [e.id]: e.val.trim() });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
        }
    };
    return (
        <div>
            <div className='sizedbox py-5 text-center'>
                <h2 style={{ color: "var(--text-color)", }}>
                    <span
                        style={{
                            background: "var(--primary-gradient-100)",
                            backgroundClip: "text",
                            WebkitTextFillColor: "transparent"
                        }}>
                        Contact</span>&nbsp;US</h2>
                <p style={{ fontSize: "18px", fontWeight: "400", color: "var(--text-color)", lineHeight: "24px" }}>Any questions or remarks? Just write us a message.</p>
                <div className='w-100 rounded-4 row g-2 gap-2 justify-content-between mt-5' style={{ boxShadow: !isMobile ? "0px 4px 5px 0px #00000033" : "" }}>
                    <div className='col-12 col-md-5 rounded-4 mt-0  p-5 text-start' style={{ background: "var(--primary-gradient-10)" }}>
                        <h3 style={{ fontSize: "30px", fontWeight: "400", color: "var(--text-color)", lineHeight: "42px" }}>Let’s Build This Business Together</h3>
                        <p style={{ fontSize: "16px", fontWeight: "400", color: "var(--text-color)", lineHeight: "18px" }}>Get in touch with us anytime!</p>

                        <div className='mt-5 d-flex flex-column'>
                            {
                                contact_info.map((item, index) => (
                                    <p style={{ fontSize: "18px", fontWeight: "400", color: "var(--text-color)", lineHeight: "24px" }}><span>{item.icon}</span>&nbsp;&nbsp;{item.value}</p>
                                ))
                            }
                        </div>
                        <ul className="d-flex gap-3 mt-5">
                            {
                                social_media.map((item, index) => (
                                    <li>
                                        <a href={item.link} target="_blank" rel="noopener noreferrer" >
                                            <span className="icon text-dark">{item.icon}</span></a>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                    <div className='col-12 col-md-6 text-start me-2'>
                        <div className="d-flex flex-column flex-md-row gap-3 mt-5">
                            <Form.Group controlId="first_name" style={{ flex: 1 }}>
                                <span
                                    style={{
                                        fontSize: "20px",
                                        fontWeight: "500",
                                        color: "#344054",
                                        fontFamily: "var(--font-body)",
                                    }}
                                >
                                    First Name
                                </span>
                                <Form.Control
                                    type="text"
                                    placeholder="First Name"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleInputChange}
                                    isInvalid={!!errors.firstName}
                                    style={{
                                        height: "48px",
                                        borderRadius: "10px",
                                        marginTop: "8px",
                                    }}
                                />
                            </Form.Group>
                            <Form.Group controlId="last_name" style={{ flex: 1 }}>
                                <span
                                    style={{
                                        fontSize: "20px",
                                        fontWeight: "500",
                                        color: "#344054",
                                        fontFamily: "var(--font-body)",
                                    }}
                                >
                                    Last Name
                                </span>
                                <Form.Control
                                    type="text"
                                    placeholder="Last Name"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleInputChange}
                                    isInvalid={!!errors.lastName}
                                    style={{
                                        height: "48px",
                                        borderRadius: "10px",
                                        marginTop: "8px",
                                    }}
                                />
                            </Form.Group>
                        </div>
                        <div className="d-flex flex-column flex-md-row gap-3 mt-3">
                            <Form.Group controlId="first_name" style={{ flex: 1 }}>
                                <span
                                    style={{
                                        fontSize: "20px",
                                        fontWeight: "500",
                                        color: "#344054",
                                        fontFamily: "var(--font-body)",
                                    }}
                                >
                                    Phone Number
                                </span>
                                <Form.Control
                                    type="text"
                                    placeholder="Phone Number"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                    isInvalid={!!errors.phone}
                                    style={{
                                        height: "48px",
                                        borderRadius: "10px",
                                        marginTop: "8px",
                                    }}
                                />
                            </Form.Group>
                            <Form.Group controlId="last_name" style={{ flex: 1 }}>
                                <span
                                    style={{
                                        fontSize: "20px",
                                        fontWeight: "500",
                                        color: "#344054",
                                        fontFamily: "var(--font-body)",
                                    }}
                                >
                                    Email
                                </span>
                                <Form.Control
                                    type="text"
                                    placeholder="Official Email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    isInvalid={!!errors.email}
                                    style={{
                                        height: "48px",
                                        borderRadius: "10px",
                                        marginTop: "8px",
                                    }}
                                />
                            </Form.Group>
                        </div>
                        <div className="d-flex flex-column flex-md-row gap-3 mt-3">
                            <Dropdown
                                style={{ flex: 1 }}
                                id="product"
                                onSelect={(val) => handleDropdownChange({ id: "product", val: val })}
                            >
                                <span
                                    style={{
                                        fontSize: "20px",
                                        fontWeight: "500",
                                        color: "#344054",
                                        fontFamily: "var(--font-body)",
                                    }}
                                >
                                    Products
                                </span>
                                <Dropdown.Toggle
                                    id="dropdown-basic"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "#000",
                                        border: "1px solid rgba(162, 161, 168, 0.2)",
                                        width: "100%",
                                        height: "48px",
                                        borderRadius: "10px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginTop: "8px",
                                    }}
                                >
                                    {formData.service || "Select"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu
                                    className="border-0 shadow-sm"
                                    style={{ width: "100%" }}
                                >
                                    {services.map((item, index) => (
                                        <Dropdown.Item eventKey={item.title}>
                                            {item.title}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <Form.Group controlId="message" style={{ flex: 1, marginTop: "15px" }}>
                            <span
                                style={{
                                    fontSize: "20px",
                                    fontWeight: "500",
                                    color: "#344054",
                                    fontFamily: "var(--font)",
                                }}
                            >
                                Message
                            </span>
                            <Form.Control
                                as="textarea"
                                rows={6}
                                placeholder=""
                                name="message"
                                value={formData.message}
                                onChange={handleInputChange}
                                isInvalid={!!errors.message}
                                style={{
                                    minHeight: "10em",
                                    maxHeight: "10em",
                                    borderRadius: "10px",
                                    marginTop: "8px",
                                }}
                            />
                        </Form.Group>
                        <div className='w-100 mt-5 px-auto'>
                            <div className='mx-auto' style={{ width: "fit-content" }}><MyButton btntext="Send Messgae" fontSize='18px' onClick={handleSubmit} /></div>
                        </div>
                        <div className='mx-auto' style={{ width: "fit-content" }}> <img style={{ marginLeft: "150px" }} src={arrow} alt='arrow'></img></div>

                    </div>
                </div>

            </div>
            <div id="faqs" className='sizedbox mt-5 text-center'>
                <Faqs faqList={faqQuestions.slice(0, 6)} />
            </div>
        </div>
    );
}

export default ContactUs;
